/**
 * Properties and methods relating to the panama user - Previously MMF.Site
 */

mmf_modules.define('utils/site',[
    'context_vars/utils/site',
    'utils/utils'
], function (
    context,
    utils
) {
    'use strict';

     var Site = utils.extend(true, {}, context);

     return Site;
});

